/**
 * @generated SignedSource<<f47626362c4f2d8dbaec082dae5189ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgBillingContainer_organization$data = {
  readonly organizationSubscriptions: {
    readonly nodes: ReadonlyArray<{
      readonly status: string;
      readonly billingPlan: {
        readonly slug: string;
      } | null;
    }>;
  };
  readonly monthlyMetrics: ReadonlyArray<{
    readonly name: string;
    readonly value: number | null;
  } | null>;
  readonly " $fragmentType": "OrgBillingContainer_organization";
};
export type OrgBillingContainer_organization$key = {
  readonly " $data"?: OrgBillingContainer_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgBillingContainer_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgBillingContainer_organization",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeDeleted",
          "value": "YES"
        }
      ],
      "concreteType": "OrganizationSubscriptionsConnection",
      "kind": "LinkedField",
      "name": "organizationSubscriptions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationSubscription",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BillingPlan",
              "kind": "LinkedField",
              "name": "billingPlan",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "organizationSubscriptions(includeDeleted:\"YES\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReportMetricResult",
      "kind": "LinkedField",
      "name": "monthlyMetrics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "9857c41cebc6c3a9298716f0d2f93065";

export default node;
